/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import ReactPlayer from 'react-player';
import { BASE_URL, IMAGE_PATHS, VIDEO_PATHS } from '../../../../constants/paths.constants';
import { universalStyles } from '../../../../app/theme';

const useStyles = makeStyles(() => ({
  ...universalStyles,
  container: {
    width: 'calc(100% + 125px)',
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: 30,
  },
  topImage: {
    width: '85%',
    marginLeft: 10,
    marginBottom: 25,
  },
  image2: {
    width: '100%',
    boxShadow: '6px 6px 10px #9E9E9E',
    maxHeight: 200,
    margin: '0 8px 0 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  image3: {
    width: '50%',
    maxHeight: 300,
    boxShadow: '6px 6px 10px #9E9E9E',
    margin: '0 8px 0 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  row: {
    marginLeft: 40,
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: 30,
  },
  scanImages: {
    width: '100%',
    boxShadow: '6px 6px 10px #9E9E9E',
    margin: 5,
    marginBottom: 15,
  },
  imageColumn: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    margin: '0 8px 0 0',
  },
  imageText: {
    paddingLeft: 10,
    fontSize: 14,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    marginTop: -20,
    paddingBottom: 25,
    fontStyle: 'italic',
  },
  video: {
    width: 'calc(100% + 125px)',
    maxHeight: 435,
    aspectRatio: '.48',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
    height: '100%',
    paddingBottom: 30,
  },
}));

const AdditionalCaseStudyImaging03 = (): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="body1" className={classes.text}>
        POSLUMA Images
      </Typography>
      <div className={classes.video}>
        <ReactPlayer className={classes.responsiveVideo} url={VIDEO_PATHS.ACS_3.path} controls />
      </div>
      <Typography variant="body1" className={classes.text}>
        Retroperitoneal Lymph Nodes
      </Typography>
      <div className={classes.container}>
        <div className={classes.imageColumn}>
          <Typography variant="body1" className={classes.imageText}>
            PET
          </Typography>
          <img
            className={classes.scanImages}
            src={`${BASE_URL}${IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[3].AXIAL_RETRO_LYMPTH_NODES_PET.path}`}
            alt={IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[3].AXIAL_RETRO_LYMPTH_NODES_PET.alt}
          />
        </div>
        <div className={classes.imageColumn}>
          <Typography variant="body1" className={classes.imageText}>
            FUSED
          </Typography>
          <img
            className={classes.scanImages}
            src={`${BASE_URL}${IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[3].AXIAL_RETRO_LYMPTH_NODES_FUS.path}`}
            alt={IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[3].AXIAL_RETRO_LYMPTH_NODES_FUS.alt}
          />
        </div>
        <div className={classes.imageColumn}>
          <Typography variant="body1" className={classes.imageText}>
            CT
          </Typography>
          <img
            className={classes.scanImages}
            src={`${BASE_URL}${IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[3].AXIAL_RETRO_LYMPTH_NODES_CT.path}`}
            alt={IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[3].AXIAL_RETRO_LYMPTH_NODES_CT.alt}
          />
        </div>
      </div>
      <div className={classes.container}>
        <div className={classes.row}>
          <img
            className={classes.image3}
            src={`${BASE_URL}${IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[3].CORONAL_RETRO_LYMPTH_NODES_FUS.path}`}
            alt={IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[3].CORONAL_RETRO_LYMPTH_NODES_FUS.alt}
          />
          <img
            className={classes.image3}
            src={`${BASE_URL}${IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[3].CORONAL_RETRO_LYMPTH_NODES_CT.path}`}
            alt={IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[3].CORONAL_RETRO_LYMPTH_NODES_CT.alt}
          />
        </div>
      </div>
    </>
  );
};

export default AdditionalCaseStudyImaging03;
